<main class="shell">

  <!-- ── Desktop / TV layout ── -->
  <section class="map" aria-label="Acorn Guild village map">
    <img class="map-art" src="assets/village-map-clean.webp" alt="Chibi animal village map" loading="eager">

    <nav class="top-nav" aria-label="Main navigation">
      <img class="nav-bar" src="assets/ui/nav/nav-bar.webp" alt="" aria-hidden="true">
      <div class="nav-links">
        <a class="nav-link nav-home" routerLink="/">Home</a>
        <a class="nav-link nav-play" routerLink="/play">Play</a>
        <a class="nav-link nav-about" routerLink="/about">About</a>
      </div>
    </nav>

    <!-- Primary play CTAs — one click to game -->
    <div class="play-ctas">
      <a class="cta-screen" routerLink="/play" aria-label="Launch game on screen">
        <span class="cta-icon">🖥</span>
        <span class="cta-label">Play on Screen</span>
        <span class="cta-sub">Host the shared display</span>
      </a>
      <a class="cta-phone" routerLink="/godot-phone" aria-label="Use phone as controller">
        <span class="cta-icon">📱</span>
        <span class="cta-label">Phone Controller</span>
        <span class="cta-sub">Join with your phone</span>
      </a>
    </div>

    <!-- Map signs (secondary navigation) -->
    <a class="map-sign town-gate" routerLink="/play" aria-label="Town Gate – Play">
      <img src="assets/ui/signs/town-gate.webp" alt="" loading="lazy">
    </a>
    <a class="map-sign guild-hall" routerLink="/about" aria-label="Guild Hall – About">
      <img src="assets/ui/signs/guild-hall.webp" alt="" loading="lazy">
    </a>
    <a class="map-sign market" routerLink="/games" aria-label="Market – Games">
      <img src="assets/ui/signs/market.webp" alt="" loading="lazy">
    </a>
    <a class="map-sign library" routerLink="/library" aria-label="Library – How To Play">
      <img src="assets/ui/signs/library.webp" alt="" loading="lazy">
    </a>
    <a class="map-sign notice-board" routerLink="/news" aria-label="Notice Board – News">
      <img src="assets/ui/signs/notice-board.webp" alt="" loading="lazy">
    </a>
  </section>

  <!-- ── Mobile / Phone layout ── -->
  <section class="phone-home" aria-label="Acorn Guild mobile home">
    <header class="phone-hero">
      <img class="phone-hero-art" src="assets/village-map-clean.webp" alt="" aria-hidden="true" loading="eager">
      <div class="phone-hero-shade" aria-hidden="true"></div>
      <div class="phone-brand">
        <span>Acorn Guild</span>
        <h1>Village Home</h1>
      </div>

      <!-- Two-button hero: the primary actions -->
      <div class="phone-hero-actions">
        <a class="phone-cta-screen" routerLink="/play">
          Play on Screen
        </a>
        <a class="phone-cta-controller" routerLink="/godot-phone">
          Use as Controller
        </a>
      </div>
    </header>

    <nav class="phone-quick-nav" aria-label="Mobile main navigation">
      <a routerLink="/play">
        <img src="assets/ui/signs/town-gate.webp" alt="" loading="lazy">
        <span>Play</span>
      </a>
      <a routerLink="/godot-phone">
        <img src="assets/ui/signs/explore-village.webp" alt="" loading="lazy">
        <span>Controller</span>
      </a>
      <a routerLink="/games">
        <img src="assets/ui/signs/market.webp" alt="" loading="lazy">
        <span>Games</span>
      </a>
      <a routerLink="/about">
        <img src="assets/ui/signs/guild-hall.webp" alt="" loading="lazy">
        <span>About</span>
      </a>
    </nav>

    <section class="phone-section phone-join" aria-label="Join the guild">
      <h2>Join The Guild</h2>
      <p>Get testing notes, room links, and cozy guild news.</p>
      <form>
        <input type="email" placeholder="Your email address" aria-label="Email address">
        <button type="button">Join</button>
      </form>
    </section>

    <section class="phone-social" aria-label="Social links">
      <h2>Follow Our Journey</h2>
      <div>
        <a href="https://discord.com" target="_blank" rel="noopener" aria-label="Discord">Discord</a>
        <a href="https://x.com" target="_blank" rel="noopener" aria-label="X / Twitter">X</a>
        <a href="https://instagram.com" target="_blank" rel="noopener" aria-label="Instagram">IG</a>
        <a href="https://youtube.com" target="_blank" rel="noopener" aria-label="YouTube">YT</a>
      </div>
    </section>
  </section>

</main>
